import { Helper } from '@utils/index'
import React, { useEffect, useState } from 'react'
import { ChevronDown } from 'lucide-react'
import {
  Dropdown,
  DropdownContainer,
  DropdownItem,
  StatusTag,
  StatusTagWrapper,
} from './style'

interface StatusProps {
  item: { status?: string }
  statuses?: string[]
  onStatusChange?: (val: string) => void
}

const Status = ({ item, statuses = [], onStatusChange }: StatusProps) => {
  const initialStatus = item?.status ?? 'Pending'

  const [selectedStatus, setSelectedStatus] = useState(initialStatus)
  const [open, setOpen] = useState(false)

  if (!initialStatus) return <span style={{ color: '#999' }}>-</span>

  const isStaticStatus =
    selectedStatus === 'Approved' ||
    selectedStatus === 'Rejected' ||
    selectedStatus === 'Solved' ||
    selectedStatus === 'Delivered' ||
    selectedStatus === 'Refund' ||
    selectedStatus === 'Completed'
  // selectedStatus === 'Win' ||
  // selectedStatus === 'Lose'

  const { text, bg } = Helper.getStatusColor(selectedStatus || initialStatus)
  useEffect(() => {
    setSelectedStatus(item?.status ?? '')
  }, [item?.status])
  const handleStatusChange = (status: string) => {
    if (status === selectedStatus) {
      setOpen(false)
      return
    }

    if (onStatusChange && !isStaticStatus) {
      onStatusChange(status)
    }

    setSelectedStatus(status)
    setOpen(false)
  }

  const isDropdownEnabled = statuses.length > 0 && !isStaticStatus

  return (
    <StatusTagWrapper>
      <DropdownContainer>
        <StatusTag
          textColor={text}
          bgColor={bg}
          onClick={() => {
            if (isDropdownEnabled) setOpen(!open)
          }}
          style={{
            cursor: isDropdownEnabled ? 'pointer' : 'default',
            opacity: isStaticStatus ? 0.7 : 1,
            userSelect: 'none',
          }}
        >
          {selectedStatus}
          {isDropdownEnabled && (
            <ChevronDown size={16} style={{ marginLeft: 6 }} />
          )}
        </StatusTag>

        {open && isDropdownEnabled && (
          <Dropdown>
            {statuses
              .filter((s) => s !== selectedStatus)
              .map((status) => {
                const { text, bg } = Helper.getStatusColor(status)
                return (
                  <DropdownItem
                    key={status}
                    onClick={() => handleStatusChange(status)}
                    textColor={text}
                    bgColor={bg}
                  >
                    {status}
                  </DropdownItem>
                )
              })}
          </Dropdown>
        )}
      </DropdownContainer>
    </StatusTagWrapper>
  )
}

export default Status
